import { Pipe, PipeTransform } from '@angular/core';
import { LicenseSlug } from 'src/app/models/selected-files-data';
@Pipe({
  name: 'getArray'
})
export class GetArrayPipe implements PipeTransform {
  constructor(){}
  transform(regularListArray: Array<any>, type: string, factorPrice: any = 1500): any {
    let tempData:Array<any> = [];
    let multipleValue = 1;
    if (type === LicenseSlug.WavStem) {
      multipleValue =  factorPrice;
    } else if (type === LicenseSlug.Exclusive) {
      multipleValue = 4;
    }
    regularListArray.filter( item => {
      if (type === LicenseSlug.WavStem) {
        tempData.push(item + multipleValue)
      } else {
        tempData.push(item * multipleValue);
      }
    });
    return tempData;
  }

}
